<template>
  <div v-if="hasAlerts" class="app-alerts">
    <div v-if="!mediaConnectIsSupported" class="app-alert-item app-alert-item--warning">
      <div class="app-alert-item__icon">
        <v-icon color="warning">status_warning</v-icon>
      </div>

      <div class="app-alert-item__content">
        <p v-if="isAdmin" class="app-alert-item__description">
          {{ t("updateARN") }}
        </p>

        <p v-else class="app-alert-item__description">
          {{ t("mediaConnectMissing") }}
        </p>
      </div>

      <div class="app-alert-item__controller">
        <v-btn v-if="isAdmin" @click="navigateArn" large>
          {{ t("manageRoleButtonLabel") }}
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { useStore } from "@/composable/useStore"
import { createTranslationModule } from "@/plugins/i18n"
import { defineComponent, computed } from "@vue/composition-api"
import { navigate } from "@/router"

export default defineComponent({
  name: "PopupAlerts",
  setup() {
    const t = createTranslationModule("WorkspaceEdit.addApps.alerts")
    const { spaceModule, organizationModule, usersModule } = useStore()

    const hasAlerts = computed(() => {
      const notSupportedMediaConnect = !mediaConnectIsSupported.value
      return notSupportedMediaConnect
    })

    const isAdmin = computed(() => {
      return usersModule.hasAdminPermissions
    })

    const mediaConnectIsSupported = computed(() => {
      return organizationModule.mediaConnectIsSupported
    })

    const navigateArn = () => {
      navigate({
        name: "Organization",
        params: {
          organizationId: spaceModule.watching.organizationId
        },
        query: {
          tab: "infrastructure"
        }
      })
    }

    return {
      t,
      navigateArn,
      isAdmin,
      hasAlerts,
      mediaConnectIsSupported
    }
  }
})
</script>
